import { render, staticRenderFns } from "./validate-invoice-payment.vue?vue&type=template&id=a5237626"
import script from "./validate-invoice-payment.vue?vue&type=script&lang=ts"
export * from "./validate-invoice-payment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports